export let customChoiceOptionListProps = {
    key: 0,
    style_option_id: null,
    charge_extra: false,
    charges: 0,
    can_choose_different_fabric: false,
    customise_option_fabric_categories: [],
    required_fabric_unit: 0,
    picture_path: '',
    is_default: false
}

export let customChoiceListProps = {
    key: 0,
    id: 0,
    style_name: '',
    display_picture: '',
    picture_path: '',
    style_options: [JSON.parse(JSON.stringify(customChoiceOptionListProps))],
    delete_option_list: []
}

export let styleChoiceOptionListProps = {
    key: 0,
    id: 0,
    option_name: '',
    option_name_translation: '',
    charge_extra: false,
    fixed_charge: false,
    charge_type: 0,
    charge_range: [0,0],
    charges: 0,
    can_choose_different_fabric: false,
    required_fabric_unit: 0,
    charge_extra_for_fabric_as_per_price_of_fabric: false,
    picture_path: '',
    is_default: false,
    is_editable: false
}

export let styleChoiceListProps = {
    key: 0,
    id: 0,
    style_name: '',
    style_name_translation: '',
    sl_no: 0,
    material: false,
    option_list: [JSON.parse(JSON.stringify(styleChoiceOptionListProps))],
    delete_option_list: []
}

export let comboProductListProps = {
    id: 0,
    tailoring_id: 0
}

export let imageListProps = {
    key: 0,
    id: 0,
    image_path: '',
    print_with_wo: false,
    use_as_profile_picture: true    
}

export let fabricConsumptionProps = {
    key: 0,
    size_id: null,
    fabric_width_list: []  
}

export let estoreVariationProps = {
    key: 0,
    fabric_id: null,
    fabric_details: {id: 0, sku_code: ''},
    sale_price: 0,
    image_list: []
}

export let dataProps = {
    id: 0,
    active: true, 
    template_name: '',  
    description: '', 
    base_sales_price: 0, 
    is_combination_item: false, 
    use_same_fabric_for_all_item: true, 
    is_fabric_required: true,
    is_fabric_optional: false,
    fabric_unit_remain_flat: false, 
    required_fabric_unit: 0, 
    fabric_sales_price_remains_flat: false, 
    hsn_sac_code: '', 
    show_item_breakup_in_invoice: false, 
    tailoring_tax_percent: 0, 
    tailoring_and_fabric_tax_percent: 0, 
    category_id: null, 
    sub_category_id: null,
    collection_id: null, 
    print_on_invoice: 0,
    profile_photo: '',
    alteration_item: false,
    discount_percent: 0,
    production_buffer_days: 0,
    customise_option_fabric_categories: [],
    pre_define_measurement_on_size: false,
    
    estore_available: false,
    estore_placement: 0,
    estore_title: '',
    estore_sub_title: '',
    estore_other_detail: '',
    estore_overview: '',
    estore_variation_list: [JSON.parse(JSON.stringify(estoreVariationProps))],
    alteration_garment: false,
    
    combination_item_list: [],
    delete_combination_item_list: [],
    
    style_choice_list: [JSON.parse(JSON.stringify(styleChoiceListProps))],
    delete_style_choice_list: [],
    
    custom_choice_list: [JSON.parse(JSON.stringify(customChoiceListProps))],
    delete_custom_choice_list: [],
    is_self_customisation_allowed: false,
    
    fabric_consumption_list: [JSON.parse(JSON.stringify(fabricConsumptionProps))],
    delete_fabric_consumption_list: [],
    trial_finish_rate: 0,
    trial_type_price_list: [],
    
    image_list: [JSON.parse(JSON.stringify(imageListProps))],
    delete_image_list: [],
    store_id: 0,
    production_capacity: 0,
    production_process_days: 0,

    fabric_id: 0,
    fabric_name: '',
    pre_define_production: false,
    pre_define_measurement_list: false,
    measurement_chart: [],
    final_measurement_chart: [],

    production_process_list: [],
    final_production_process_list: []
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringMaster/properties.js